import { useEffect, useLayoutEffect, useRef } from 'react';
import { useVitalMetric, VitalDurationMetric } from '@funtech-int/yango-shared';

import { EnhancedPlayback } from '../lib/enhancedPlayback';

export interface PlaybackMetrics {
    firstFrame: VitalDurationMetric;
}

export const usePlaybackMetrics = (
    playback: EnhancedPlayback | null,
    { firstFrame }: PlaybackMetrics
) => {
    const firstFrameDuration = useVitalMetric(firstFrame);
    const hasBegunMeasureRef = useRef(false);

    useLayoutEffect(() => {
        if (hasBegunMeasureRef.current) return;

        firstFrameDuration.begin();

        hasBegunMeasureRef.current = true;
    }, [firstFrameDuration]);

    useEffect(() => {
        if (!playback) return;

        return playback.listen('playbackstart', firstFrameDuration.end);
    }, [playback, firstFrameDuration]);
};
